// Media Queries

import { css } from 'styled-components';

export const sizes = {
    xxxl: 2000,
    xxl: 1800,
    xl: 1600,
    laptop: 1440,
    large: 1200,
    medium: 992,
    small: 768,
    xsmall: 450,
    xxsmall: 376,
};

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = sizes[label] / 16;
    accumulator[label] = (...args) => css`
        @media (min-width: ${emSize}em) {
            ${css(...args)};
        }
    `;
    return accumulator;
}, {});

// ${media.large`font-size: 40px;`};

// Transitions
export const TransitionMixin = (transitionSpeed) => ` 
      -moz-transition:    ${transitionSpeed};
      -o-transition:      ${transitionSpeed};
      -webkit-transition: ${transitionSpeed};
      transition:         ${transitionSpeed};    
  `;

// ${TransitionMixin('.25s')}

export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

export const shuffle = function (array) {
    var currentIndex = array.length;
    var temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};
